import React, { memo, useMemo } from 'react'

import useTranslations from '../../../../hooks/useTranslations'
import ANTDButton from '../../../../shared/antd/ANTDButton'
import ANTDCheckbox, {
  ANTDCheckboxGroup,
} from '../../../../shared/antd/ANTDCheckbox'
import ANTDColumn from '../../../../shared/antd/ANTDColumn'
import ANTDDivider from '../../../../shared/antd/ANTDDivider'
import ANTDModal from '../../../../shared/antd/ANTDModal'
import ANTDRow from '../../../../shared/antd/ANTDRow'
import ANTDSelect from '../../../../shared/antd/ANTDSelect'
import { isEqual, length } from '../../../../utils/javascript'
import {
  COLLECTION_CENTER,
  DIRECT_DEALER,
  DIRECT_INDIVIDUAL,
} from '../../jobs.description'

const ExportColumn = ({
  selectExportColModal,
  onSelectExportCol,
  onSelectAllColumn,
  onSelectColumn,
  excelColumn,
  loading,
  onSaveReportFormat,
  showSaveReportFormat = false,
  searchByFilter = false,
  exportSearchBy,
  exportSearchValue,
  onExportSearchByChange,
  setExportSearchValue,
}) => {
  const { t } = useTranslations()

  const exportSearchByOptions = useMemo(
    () => [
      { label: t('job_Status'), value: 'JOB_STATUS' },
      { label: t('job_Source'), value: 'SOURCE' },
    ],
    [],
  )

  const exportJobStatusOptions = useMemo(
    () =>
      [
        'BASIC_VEHICLE_DETAILS_PENDING',
        'BASIC_VEHICLE_DETAILS_COMPLETED',
        'PRE_INSPECTION_PENDING',
        'PRE_INSPECTION_COMPLETED',
        'RC_FORM2_PENDING',
        'RC_FORM2_COMPLETED',
        'COD_PENDING',
        'COD_COMPLETED',
        'SALES_COMMERCIALS_PENDING',
        'SALES_COMMERCIALS_COMPLETED',
      ].map(value => ({ label: t(value), value })),
    [],
  )

  const exportSourceOptions = useMemo(
    () => [
      {
        label: t(DIRECT_INDIVIDUAL),
        value: 'DIRECT_INDIVIDUAL',
      },
      {
        label: t(DIRECT_DEALER),
        value: 'DIRECT_DEALER',
      },
      {
        label: t(COLLECTION_CENTER),
        value: 'COLLECTION_CENTER',
      },
    ],
    [],
  )

  const exportSearchValueOptions = useMemo(
    () =>
      exportSearchBy
        ? isEqual(exportSearchBy, 'SOURCE')
          ? exportSourceOptions
          : exportJobStatusOptions
        : [],
    [exportSearchBy, exportSourceOptions, exportJobStatusOptions],
  )

  return (
    <>
      {selectExportColModal?.open && (
        <ANTDModal
          title={t('job_ColumnsForExport')}
          centered
          open={selectExportColModal?.open}
          onCancel={onSelectExportCol}
          footer={false}
          width={1100}
        >
          {searchByFilter && (
            <ANTDRow gutter={[12, 12]} className="mb-15">
              <ANTDColumn xs={24} md={12}>
                <div className="mb-5">{t('job_SearchBy')} :</div>
                <ANTDSelect
                  className="w-100"
                  options={exportSearchByOptions}
                  value={exportSearchBy}
                  onChange={onExportSearchByChange}
                />
              </ANTDColumn>
              <ANTDColumn xs={24} md={12}>
                <div className="mb-5">{t('txt_Search')} :</div>
                <ANTDSelect
                  allowClear
                  className="w-100"
                  options={exportSearchValueOptions}
                  value={exportSearchValue}
                  onChange={setExportSearchValue}
                />
              </ANTDColumn>
            </ANTDRow>
          )}
          <ANTDDivider />
          <ANTDCheckbox
            value={selectExportColModal?.selectedColumn}
            onChange={onSelectAllColumn}
            className="ml-25 mb-10"
            defaultChecked={isEqual(
              length(selectExportColModal?.selectedColumn),
              length(excelColumn),
            )}
          >
            {t('job_SelectAll')}
          </ANTDCheckbox>
          <ANTDCheckboxGroup
            onChange={onSelectColumn}
            value={selectExportColModal?.selectedColumn}
          >
            <ul className="export-columns">
              {excelColumn.map(({ columnKey, id }, ind) => (
                <li key={ind}>
                  <ANTDCheckbox value={id}> {t(columnKey)}</ANTDCheckbox>
                </li>
              ))}
            </ul>
          </ANTDCheckboxGroup>

          <div className="mt-20 text-center">
            <ANTDButton
              type="primary"
              onClick={onSelectExportCol}
              loading={loading}
            >
              {t('btn_Save')}
            </ANTDButton>
            {showSaveReportFormat &&
              length(selectExportColModal?.selectedColumn) > 0 && (
                <ANTDButton
                  type="link"
                  onClick={() => {
                    onSelectExportCol()
                    onSaveReportFormat()
                  }}
                  className="ml-10"
                  style={{ color: '#52c41a' }}
                >
                  {t('job_SaveReportFormat')}
                </ANTDButton>
              )}
          </div>
        </ANTDModal>
      )}
    </>
  )
}

export default memo(ExportColumn)
